import api from '../../services/api';

/*
 * The requests the legacy `useEcommerceIntegrations` hook made, with the same
 * paths. Every `setting_ecommerces` endpoint resolves the company from
 * `request.user.seller`, so they only work for a seller.
 */

export const getSettingEcommercesRequest = () => api.get('companies/setting_ecommerces/');

export const createSettingEcommerceRequest = (settingEcommerce) =>
  api.post('companies/setting_ecommerces/create', { setting_ecommerce: settingEcommerce });

export const updateSettingEcommerceRequest = (id, settingEcommerce) =>
  api.patch(`companies/setting_ecommerces/update/${id}`, { setting_ecommerce: settingEcommerce });

export const deleteSettingEcommerceRequest = (id) =>
  api.delete(`companies/setting_ecommerces/delete/${id}`);

export const initMeliAuthRequest = (settingEcommerce) =>
  api.post('companies/setting_ecommerces/meli/authorization/init/', {
    setting_ecommerce: settingEcommerce,
  });

/**
 * @param {{shop: string, client_id: string, client_secret: string, warehouse: number}} payload
 */
export const initShopifyAuthRequest = (payload) =>
  api.post('companies/setting_ecommerces/shopify/authorization/init/', payload);

/** The seller's warehouses, from `useWarehouses().fetchSettingEcommerceWarehouses`. */
export const getEcommerceWarehousesRequest = () => api.get('warehouses/all_warehouses/');
